module.exports = __webpack_public_path__ + "static/media/Yelp.2dedc931.png";